import { render, staticRenderFns } from "./RadioThumb.vue?vue&type=template&id=a4265c74&scoped=true&"
import script from "./RadioThumb.vue?vue&type=script&lang=js&"
export * from "./RadioThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4265c74",
  null
  
)

export default component.exports